import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import styles from "./modal.module.css"

export type ErrorModalProps = {
    seconderyErrorContent: string;
    errorContent: string;
    headerTitle: string;
}


const ErrorModal = NiceModal.create(({ seconderyErrorContent, errorContent, headerTitle }: ErrorModalProps) => {
    const modal = useModal();

    const handleModalToggle = () => {
        modal.hide();
    };

    return (
        <>
            <div>
                <Dialog
                    sx={{ "& .MuiDialog-paper": { borderRadius: '12px', overflowY: "unset" } }}
                    open={modal.visible}
                    onClose={() => modal.hide()}
                >
                    <a className={styles.modalClose} onClick={handleModalToggle}>
                        &times;
                    </a>
                    <DialogTitle className={styles.modalHeader} style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                        <div className="login_logo">
                            <img src="/assets/images/shoshke_logo_notxt.svg"></img>

                        </div>
                    </DialogTitle>
                    <DialogContent className={styles.modalContent}>
                        <div style={{ marginTop: 20, fontSize: 28, fontWeight: 700 }}>
                            {errorContent}
                        </div>
                        <div style={{ marginTop: 30 }}>
                            {seconderyErrorContent}
                        </div>

                    </DialogContent>
                </Dialog>
            </div>
        </>


    )
})


export default ErrorModal;